import React, {useState} from 'react';
import {Route, Redirect} from 'react-router-dom';
import { Spin, Space } from 'antd';

import {getCurrentBranchUuId, getToken} from './helpers/token';
import {UserContext} from './context';
import AuthService from './services/AuthService';
import SelectBranch from './pages/auth/SelectBranch';

const PrivateRoute = (
    {location, component: RouteComponent, ...rest}
) => {
    const [currentUser, setCurrentUser] = useState(null);
    const token = getToken();
    const hasToken = !!token;
    const currentBranch = getCurrentBranchUuId();
    let Component;

    if (currentUser) {
        if (!currentBranch) {
            Component = () => (
                <SelectBranch/>
            );
        } else {
            Component = props => (
                <RouteComponent {...props}/>
            );
        }

    } else if (hasToken) {
        Component = () => (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100vh'}}>
                <Space size="middle">
                    <Spin size="large" />
                </Space>
            </div>
        );
    } else {
        Component = () => (
            <Redirect to={{
                pathname: "/login",
                state: {from: location}
            }}/>
        );

    }

    if (!currentUser && hasToken) {
        AuthService.getCurrentUser().then((user) => {
            setCurrentUser(user);
        })
    }

    return (
        <UserContext.Provider value={currentUser}>
            <Route {...rest} render={props => Component(props)}/>
        </UserContext.Provider>
    );
};

PrivateRoute.propTypes = {};

export default PrivateRoute;